import { SyntheticEvent, useCallback, useState } from "react";
import FocusLock from "react-focus-lock";
import useClickAway from "@/core/helpers/useClickAway";
import { Button, TextInput } from "@/shared/ui";
import { Country } from "@/domains/auth/constants/country";
import { AuthState } from "@/domains/auth/slice";

type Props = {
  onSubmit: (e: SyntheticEvent<HTMLFormElement>) => void;
  country: AuthState["countries"][0];
  onChangeCountry: (value: Country) => void;
  phoneNumber: string;
  onPhoneNumberChange: (value: string) => void;
  error?: string;
  pending?: boolean;
  countries: AuthState["countries"];
};

export default function PlayerMenuSettingsSafetyEnableTfaSMSSend({
  onSubmit,
  country,
  onChangeCountry,
  phoneNumber,
  onPhoneNumberChange,
  error = "",
  pending = false,
  countries,
}: Props) {
  const [showCountrySelect, setShowCountrySelect] = useState(false);
  const [touch, setTouch] = useState(false);

  const closeSelectHandler = useCallback(() => {
    setShowCountrySelect(false);
  }, []);

  const toggleSelectHandler = useCallback(() => {
    setShowCountrySelect((state) => !state);
  }, []);

  const ref = useClickAway(closeSelectHandler);

  return (
    <FocusLock className="contents">
      <form
        noValidate
        onSubmit={(e) => {
          onSubmit(e);
          setTouch(true);
        }}
        className="gap-3 grow flex flex-col h-full"
      >
        <div>
          <div className="text-white/60 text-15 font-medium">
            На указанный номер телефона будет отправлено сообщение с кодом для подтверждения
          </div>
          <div className="text-white text-16 font-medium mt-5">Введите номера телефона:</div>
          <div className="flex items-start gap-2 mt-2.5">
            <div
              ref={ref}
              className="relative h-12 px-5 outline-none font-medium rounded-xl bg-dark-800 w-[8.875rem] flex items-center"
            >
              <button
                type="button"
                className="w-full h-full flex items-center"
                onClick={toggleSelectHandler}
              >
                <div className="font-arial text-white text-10 h-1 leading-[.75]">▼</div>
                <img src="/svg/flag-russia.svg" alt="" className="w-5 h-5 ml-3" />
                <div className="text-white text-14 font-medium ml-2">{country.short}</div>
                <div className="grow text-right text-14 fonr-medium text-white/60">
                  {country.code}
                </div>
              </button>
              {showCountrySelect && (
                <div className="absolute flex flex-col rounded-xl bg-dark-800 top-[105%] left-0 w-full overflow-clip">
                  {countries.map((item) => (
                    <button
                      type="button"
                      key={item.code}
                      onClick={() => {
                        onChangeCountry(item.country);
                        closeSelectHandler();
                      }}
                      className="flex items-center justify-between py-4 px-5 hover:bg-dark-700/20 transition cursor-pointer"
                    >
                      <div className="text-white text-14 font-medium">{country.country}</div>
                      <div className="grow text-right text-14 fonr-medium text-white/60">
                        {country.code}
                      </div>
                    </button>
                  ))}
                </div>
              )}
            </div>
            <TextInput
              type="text"
              placeholder="(___)-___-__-__"
              value={phoneNumber}
              invalid={touch && !phoneNumber ? "Введите номер телефона" : ""}
              onChange={onPhoneNumberChange}
              className="text-left grow"
              loading={pending}
            />
          </div>
        </div>

        <div className="mt-auto grid gap-2.5">
          {!!error && <div className="alert alert--danger">*{error}</div>}
          <Button submit className="w-full" loading={pending}>
            Отправить код
          </Button>
        </div>
      </form>
    </FocusLock>
  );
}
